<div class="flex flex-col gap-3 w-full py-4  md:border-top bg-white">
    <!-- Ttile -->
    <div class="w-full">
        <h2 class="text-xl text-black font-bold">مشخصات کلی اقامتگاه و ویلا</h2>
    </div>
    <ng-container *ngFor="let item of dataSource">
        <div class="w-full flex items-center gap-2">
            <i class="{{item?.Icon ? item.Icon : 'ico-roomnet'}}" class="text-2xl"></i>
            <span class="text-base font-bold">{{item?.Title}}</span>
        </div>
        <div class="w-full" *ngFor="let details of item?.Details">
            <p class="text-base text-black-300">{{details}}</p>
        </div>
    </ng-container>
</div>